import React from "react";

const Avatar = ({ src, width, height, style, alt }) => {

  const avatarStyle = {
    width,
    height,
    ...style
  };

  return (
    <div className="cm-avatar" style={avatarStyle}>
      <img src={src} alt={alt || ''} />
    </div>
  )
};

export default Avatar;
Avatar.defaultProps = {
  src: '',
  width: '96px',
  height: '96px',
  style: {}
};
